import { useEffect, useRef, useCallback } from 'react';

const useBodyClicker = (callback) => {
  const excludedElementRef = useRef(null);

  const handleClick = useCallback(
    (event) => {
      if (excludedElementRef.current && excludedElementRef.current.contains(event.target)) {
        return;
      }
      callback();
    },
    [callback],
  );

  useEffect(() => {
    const handleBodyClick = (event) => {
      if (excludedElementRef.current) {
        handleClick(event);
      }
    };

    document.body.addEventListener('click', handleBodyClick);

    return () => {
      document.body.removeEventListener('click', handleBodyClick);
    };
  }, [handleClick]);

  return excludedElementRef;
};

export default useBodyClicker;
